import React from 'react';
import axios from 'axios';
import { config } from '../../../app/config';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../../actions';
import TranslationService from "../../../app/services/TranslationService";
import {Button} from "../../icymat-design/Button";
import {LabeledInput} from "../../icymat-design/LabeledInput";


class Dialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newBook: ''
        }
    }

    saveEvent = () => {
        this.props.preloaderShow();
        let that = this;

        axios.post(config.apiAddress + '/app/note/books/new', {title: this.state.newBook, color: 'gray'})
            .then(function (response) {
                //I'm not hide poreloader because it will be hidden by parent after reloading data
                that.props.alert(TranslationService.trans(that.props.language, 'note.actions.book_created'));
                that.setState({newBook: ''});
                that.props.onSuccess(response.data.id);
            }).catch(function(error) {
                that.props.preloaderHide();
                that.props.alert(TranslationService.trans(that.props.language, 'common.actions.save_failed'));
            });
    };

    isOpen = () => {
        return (this.props.show ? ' imd-opened' : null);
    };

    render() {
        return (
            <dialog className={"imd-dialog imd-dialog-sm imd-bg-transparent-black" + this.isOpen()}>
                <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                    <header className="imd-text-contrast">
                        {TranslationService.trans(this.props.language, 'note.new_book')}
                        <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => this.props.closeEvent()} />
                    </header>

                    <div className="imd-dialog-content">
                        <LabeledInput
                            label={TranslationService.trans(this.props.language, 'common.name')}
                            color={'main'}
                            value={this.state.newBook}
                            onChange={(e) => this.setState({newBook: e.target.value})}
                            buttonText={TranslationService.trans(this.props.language, 'common.add')}
                            buttonOnClick={() => this.addCategory()}
                        />
                    </div>

                    <footer>
                        <Button
                            color={'accent'}
                            secondary={true}
                            text={TranslationService.trans(this.props.language, 'common.cancel')}
                            onClick={() => this.props.closeEvent()}
                        />
                        <Button
                            color={'main'}
                            text={TranslationService.trans(this.props.language, 'common.create')}
                            onClick={this.saveEvent}
                        />
                    </footer>
                </div>
            </dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        language: TranslationService.getLanguage(state.user)
    }
};

export const NewBookDialog = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(Dialog);
